import { saleForm } from '../../fixed/sales/saleForm';
import { SaleList } from '../../fixed/sales/saleList';

export const baseSales = {
  title: 'Ventas',
  endPoint: 'sale',
  onSubmit: 'submitAndStaySale',
  isSearchable: false,
  listOptions: {
    params: {
      filter: ['oportunity||$eq||false'],
      // extraUrl: 'find/all',
    },
    columns: SaleList,
  },
  form: saleForm,
};
